import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';

import { NewsIndexContainer } from 'hb-react/frontoffice/apps/NewsIndex/containers/NewsIndexContainer';
import { type Config } from 'hb-react/frontoffice/apps/NewsIndex/types';
import NewsPublished from 'hb-react/shared/apps/News/NewsPublished';
import { NewsPackage } from 'hb-react/shared/apps/News/NewsPublished/Package';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

export const NewsIndexClient = ({ config }: { config: Config }) => {
  const { flagEvNewsPackage, flagEvNewsRevamp } = useFeatureFlag();

  const NewsPublishedComponent =
    flagEvNewsPackage && flagEvNewsRevamp ? NewsPackage : NewsPublished;

  return (
    <ReactRouterRoutes>
      <Route index element={<NewsIndexContainer config={config} />} />
      <Route
        path=":newsId"
        element={<NewsPublishedComponent config={config} />}
      />
    </ReactRouterRoutes>
  );
};

export default NewsIndexClient;
